import React from "react";
import { Helmet } from "react-helmet-async";
import HeroBanner from "../../../Hero/HeroBanner";
import HeroPicBig from "../../../../../assets/medical/examinations/packages/torch/torch_banner_nagy.png";
import HeroPicSmall from "../../../../../assets/medical/examinations/packages/torch/torch_banner_kicsi.png";
import GoToPriceMultiple from "../GoToPrice/GoToPriceMultiple";
import { examinationPackages } from "../../exams/examinationPackages";
import ExamContent from "../ExamContent/ExamContent";
import ExamCTA from "../../ExamCTA/ExamCTA";

const ExamPackageTorch = () => {
  const torchTitle = examinationPackages[4].name;
  const torchSuggestedTo = examinationPackages[4].suggestedTo;
  const torchContains = examinationPackages[4].contains;

  // Create structured data for TORCH testing
  const torchTestingStructuredData = {
    "@context": "https://schema.org",
    "@type": "MedicalTest",
    name: "TORCH fertőzések vizsgálata - Bálint Analitika",
    description:
      "A Bálint Analitika laboratórium TORCH szűrővizsgálata, amely magában foglalja a Toxoplasma, Rubella, Cytomegalovírus és Herpes vírusok kimutatását.",
    relevantSpecialty: ["Obstetrics", "InfectiousDisease", "Pediatrics"],
    medicineSystem: "Conventional Medicine",
    usedToDiagnose: "TORCH infections",
    normalRange: "Negative for pathogens",
    affectedBy: [
      "Immune system status",
      "Pregnancy",
      "Prior exposure to pathogens",
    ],
    procedure: "Blood test panel for antibody detection",
    serviceProvider: {
      "@type": "MedicalBusiness",
      name: "Bálint Analitika Laboratórium",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Kondorfa utca 6.",
        addressLocality: "Budapest",
        postalCode: "1116",
        addressRegion: "XI. kerület",
        addressCountry: "HU",
      },
    },
    offers: {
      "@type": "Offer",
      availability: "InStock",
      priceCurrency: "HUF",
      priceSpecification: {
        "@type": "PriceSpecification",
        price: "Varies by specific test",
      },
    },
  };

  return (
    <>
      <Helmet>
        <title>
          TORCH fertőzések vizsgálata | Várandós szűrés | Bálint Analitika
        </title>
        <meta
          name="description"
          content="TORCH fertőzések (Toxoplasma, Rubella, CMV, Herpesz) szűrővizsgálata várandósok számára a Bálint Analitika budapesti laboratóriumában. Biztonságos és pontos eredmények."
        />
        <meta
          name="keywords"
          content="TORCH fertőzések, toxoplasma vizsgálat, rubella teszt, cytomegalovírus, CMV teszt, herpesz vizsgálat, várandós szűrés Budapest"
        />
        <link
          rel="canonical"
          href="https://balintanalitika.hu/orvosdiagnosztika/vizsgalatok/csomagok/torch"
        />
        <script type="application/ld+json">
          {JSON.stringify(torchTestingStructuredData)}
        </script>
      </Helmet>

      <HeroBanner
        srcBig={HeroPicBig}
        srcSmall={HeroPicSmall}
        alt="TORCH fertőzések szűrővizsgálata a Bálint Analitika laboratóriumban"
      />

      <main className="torch-package-page">
        <div className="container">
          <header className="torch-package-header">
            <h1 className="heading-primary">TORCH fertőzések vizsgálata</h1>
            <p className="base-p-text">
              A Bálint Analitika laboratórium Budapest XI. kerületében TORCH
              fertőzések szűrővizsgálatát kínálja, különösen várandósok és
              családtervezők számára. A TORCH mozaikszó a Toxoplasma, egyéb
              fertőzések (Other), Rubella (rózsahimlő), Cytomegalovírus (CMV) és
              Herpes simplex vírusok vizsgálatát foglalja magában.
            </p>
          </header>

          <section className="torch-package-content">
            <ExamContent
              title={torchTitle}
              suggestedTo={torchSuggestedTo}
              items={torchContains}
              isPackage={false}
              itemType="https://schema.org/MedicalTest"
            />

            <div className="exam-package-benefits">
              <h2 className="heading-secondary">
                Miért fontos a TORCH vizsgálat?
              </h2>
              <p className="base-p-text">
                A TORCH fertőzések különösen veszélyesek lehetnek a várandósság
                során, mivel átjuthatnak a méhlepényen és súlyos fejlődési
                rendellenességeket okozhatnak a magzatnál. A szűrővizsgálat
                segít megállapítani, hogy fennáll-e aktuális fertőzés, vagy
                volt-e korábban fertőzés, ami védettséget biztosíthat.
              </p>

              <h3 className="heading-tertiary">A TORCH fertőzések hatásai:</h3>
              <ul className="exam-package-base-list">
                <li>
                  <strong>Toxoplasma gondii:</strong> Vetélést, koraszülést,
                  fejlődési rendellenességeket okozhat
                </li>
                <li>
                  <strong>Rubella vírus:</strong> Congenitalis rubella szindróma
                  kialakulásához vezethet
                </li>
                <li>
                  <strong>Cytomegalovírus (CMV):</strong> Hallás- és
                  látáskárosodást, valamint neurológiai problémákat okozhat
                </li>
                <li>
                  <strong>Herpes simplex vírus:</strong> Súlyos újszülöttkori
                  fertőzéshez vezethet
                </li>
              </ul>

              <h3 className="heading-tertiary">
                Kinek ajánljuk a vizsgálatot?
              </h3>
              <ul className="exam-package-base-list">
                <li>Várandósoknak, különösen az első trimeszterben</li>
                <li>Családtervezőknek a várandósság előtt</li>
                <li>Ismételt vetélést átélt nőknek</li>
                <li>
                  Magas kockázatú foglalkozást végző várandósoknak (pl.
                  egészségügyi dolgozók, óvodapedagógusok)
                </li>
              </ul>
            </div>

            <div className="torch-package-actions">
              <GoToPriceMultiple />

              <div
                className="torch-package-contact"
                itemScope
                itemType="https://schema.org/MedicalOrganization"
              >
                <h3 className="heading-tertiary">
                  Konzultáció és időpontfoglalás
                </h3>
                <p className="base-p-text">
                  A TORCH vizsgálatokkal kapcsolatban szakértői konzultációt
                  biztosítunk.
                </p>
                <ExamCTA />
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
};

export default ExamPackageTorch;
